import { Button, styled } from "@mui/material";
import { THEME } from "../../../config";

const ClearDbButton = styled(Button)(() => ({
    fontWeight: 500,
    textTransform: "none",
    color: THEME.palette.text.secondary
}))

export default ClearDbButton